import styles from "./home.module.css";
import { FaTelegramPlane } from "react-icons/fa";
import { AiOutlineInstagram } from "react-icons/ai";
import { BsTwitter } from "react-icons/bs";
function Footer() {
  return (
    <div className={` ${styles.footConainer}`}>
      <div
        className={`d-flex container  justify-content-around   flex-wrap ${styles.footConainers}`}
      >
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot}`}>
          <p className={styles.textHeadFoot}>کریپتو زوم</p>
          <a className={styles.textAFoot}>درباره ما</a>
          <a className={styles.textAFoot}>تماس با ما</a>
          <a className={styles.textAFoot}>قوانین ما</a>
          <a className={styles.textAFoot}>پشتیبانی</a>
          <a className={styles.textAFoot}> بلاگ</a>
          <a className={styles.textAFoot}>کالج </a>
          <a className={styles.textAFoot}> فرصت های شغلی</a>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot}`}>
          <p className={styles.textHeadFoot}>اطلاعات بازار</p>
          <a className={styles.textAFoot}>نقشه بازار بورس</a>
          <a className={styles.textAFoot}>تکنیکال</a>
          <a className={styles.textAFoot}>دیده‌بان</a>
          <a className={styles.textAFoot}>پیام ناظر بورس</a>
          <a className={styles.textAFoot}> اطلاعیه‌های کدال</a>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot9}`}>
          <p className={styles.textHeadFoot}>سرمایه‌گذاری</p>
          <a className={styles.textAFoot}>صندوق‌های سرمایه‌گذاری</a>
          <a className={styles.textAFoot}>سهام عدالت</a>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot9}`}>
          <p className={styles.textHeadFoot}>بیشتر یاد بگیرید</p>
          <a className={styles.textAFoot}>راهنمای معاملات آنلاین</a>
          <a className={styles.textAFoot}>راهنمای مدیریت</a>
          <a className={styles.textAFoot}>راهنمای پرتفوی لحظه‌ای</a>
          <a className={styles.textAFoot}>معرفی خدمات </a>
        </div>
        <div className={` d-flex pt-4   ${styles.widthFootTelegram}`}>
          <p className={styles.textPFoot}>ما را در فضای مجازی دنبال کنید</p>
          <div className={styles.telegramDiv}>
            <FaTelegramPlane className={styles.telegramIcon} />
          </div>
          <div className={styles.telegramDiv}>
            <AiOutlineInstagram className={styles.telegramIcon} />
          </div>
          <div className={styles.telegramDiv}>
            <BsTwitter className={styles.telegramIcon} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
